import React from 'react';
import { FileWarningIcon } from 'lucide-react';
export function LegalDraftNotice() {
  return <div role="note" className="flex gap-4 border border-gold/60 bg-gold-wash p-5 sm:p-6" data-id="element-328" data-mp="3caxa5bfmkqwn">
      <FileWarningIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-deep" aria-hidden="true" data-id="element-329" data-mp="2yjio0vqf89ld" />
      <div data-id="element-330" data-mp="32kccprbotsfb">
        <p className="text-[15px] font-semibold text-navy" data-id="element-331" data-mp="32jssu52h8tyn">Draft — requires legal review before publication</p>
        <p className="mt-1 text-sm leading-relaxed text-ink" data-id="element-332" data-mp="2ojrrkoiavkin">
          This document is a working draft provided for structure only. It has not been reviewed by a qualified
          lawyer and must not be relied upon or published until it has been reviewed and approved. Items in square
          brackets are placeholders awaiting confirmed details.
        </p>
      </div>
    </div>;
}